<div class="input-group margin-top-20">
  <input id="InputPanel" type="text" readonly="" class="form-control searchField padding-right-30"  [formControl]="formControl" [formlyAttributes]="field"
  [ngClass]="{'has-value': formControl.value, 'padding-left-20': field.key === 'preApprovalTag' }">
  <label for="InputPanel">{{field.templateOptions.label}}<span *ngIf="field.templateOptions.required">*</span></label>
  <span class="icons z-0" *ngIf="!formControl.disabled" (click)="fnOpenSelectionPanel()">
      <a><i aria-hidden="true" class="fas fa-chevron-circle-right text-logo-blue"></i></a>
  </span>
</div>